
export default angular.module('cwel', []);



// WEBPACK FOOTER //
// ./cwel/script/app.es